import React, { useState, useEffect } from 'react';
import { db } from '../serices/firebase';
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { motion } from 'framer-motion';

const SponsorStrip = () => {
  const [sponsors, setSponsors] = useState([]);

  useEffect(() => {
    const getSponsors = async () => {
      try {
        const q = query(collection(db, "sponsors"), orderBy("createdAt", "desc"));
        const snap = await getDocs(q);
        setSponsors(snap.docs.map(d => d.data()));
      } catch (err) { console.error(err); }
    };
    getSponsors();
  }, []);

  if (sponsors.length === 0) return null;

  const sponsorList = [...sponsors, ...sponsors, ...sponsors]; // Triple for smoother loop

  return (
    <div className="w-full mt-6 py-16 border-y border-white/5 bg-white/[0.01] relative overflow-hidden">
      <p className="text-center text-[9px] font-black tracking-[0.5em] text-[#D4AF37]/40 uppercase mb-16 italic">
        Official Event Partners
      </p>

      {/* Edge Fades */}
      <div className="absolute inset-y-0 left-0 w-24 md:w-64 bg-gradient-to-r from-black via-black/80 to-transparent z-10 pointer-events-none" />
      <div className="absolute inset-y-0 right-0 w-24 md:w-64 bg-gradient-to-l from-black via-black/80 to-transparent z-10 pointer-events-none" />

      <div className="flex">
        <motion.div 
          className="flex items-center gap-20 md:gap-40 pr-20 md:pr-40"
          animate={{ x: [0, "-33.33%"] }} // Adjusted for the triple list
          transition={{ 
            ease: "linear", 
            duration: sponsors.length * 5, 
            repeat: Infinity 
          }}
        >
          {sponsorList.map((s, idx) => (
            <div key={idx} className="flex flex-col items-center gap-6 shrink-0">
              {/* 
                  FIX: Increased height from h-14 to h-20/h-28.
                  This allows square logos to become much larger before hitting the ceiling.
              */}
              <div className="h-16 md:h-24 w-32 md:w-56 flex items-center justify-center">
                <img 
                  src={s.logoUrl} 
                  alt={s.name} 
                  className="max-h-full max-w-full object-contain hover:opacity-100 hover:grayscale-0 hover:scale-110 transition-all duration-500" 
                />
              </div>
              
              <span className="text-[7px] md:text-[9px] font-black uppercase tracking-[0.4em] text-yellow-600 group-hover:text-white transition-colors italic whitespace-nowrap">
                {s.name}
              </span>
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default SponsorStrip;














/*import React, { useState, useEffect } from 'react';
import { db } from '../serices/firebase';
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { motion } from 'framer-motion';

const SponsorStrip = () => {
  const [sponsors, setSponsors] = useState([]);

  useEffect(() => {
    const getSponsors = async () => {
      try {
        const q = query(collection(db, "sponsors"), orderBy("createdAt", "desc"));
        const snap = await getDocs(q);
        setSponsors(snap.docs.map(d => d.data()));
      } catch (err) { console.error(err); }
    };
    getSponsors();
  }, []);

  if (sponsors.length === 0) return null;

  // We need at least enough logos to fill the screen width twice.
  // If you have very few sponsors (less than 6), we loop them more.
  const sponsorList = sponsors.length < 10 ? [...sponsors, ...sponsors, ...sponsors] : [...sponsors, ...sponsors];

  return (
    <div className="w-full mt-20 py-12 border-y border-white/5 bg-white/[0.01] relative overflow-hidden">
      <p className="text-center text-[9px] font-black tracking-[0.5em] text-[#D4AF37]/40 uppercase mb-12 italic">
        Official Event Partners
      </p>

      
      <div className="absolute inset-y-0 left-0 w-20 md:w-40 bg-gradient-to-r from-black to-transparent z-10 pointer-events-none" />
      <div className="absolute inset-y-0 right-0 w-20 md:w-40 bg-gradient-to-l from-black to-transparent z-10 pointer-events-none" />

      <div className="flex">
        <motion.div 
          className="flex items-center gap-16 md:gap-32 pr-16 md:pr-32"
          animate={{ x: [0, "-50%"] }} // Only animate half-way (the length of one full set)
          transition={{ 
            ease: "linear", 
            duration: sponsors.length * 6,
            repeat: Infinity 
          }}
        >
          {sponsorList.map((s, idx) => (
            <div key={idx} className="flex flex-col items-center gap-4 shrink-0 min-w-[120px] md:min-w-[180px]">
              <div className="h-10 md:h-14 flex items-center justify-center">
                <img 
                  src={s.logoUrl} 
                  alt={s.name} 
                  className="max-h-full max-w-full object-contain opacity-40 grayscale hover:opacity-100 hover:grayscale-0 transition-all duration-500" 
                />
              </div>
              <span className="text-[7px] md:text-[8px] font-black uppercase tracking-[0.3em] text-white/20 italic whitespace-nowrap">
                {s.name}
              </span>
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default SponsorStrip;*/
